import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material'
import { Code } from '@mui/icons-material'
import { shareDialog } from './RiskStoryShareDialog.styles'
import { useState } from 'react'
import { RiskStoryEmbedScript } from './RiskStoryEmbedScript'

export const RiskStoryShareDialog = ({
  shareDialogOpen,
  isStoryPublic,
  storyLink,
  onCopy,
  onClose,
}: {
  shareDialogOpen: boolean
  isStoryPublic: boolean
  storyLink: string
  onCopy: (text: string, message: string) => () => Promise<void>
  onClose: (event: React.MouseEvent) => void
}) => {
  const [embedDialogOpen, setEmbedDialogOpen] = useState(false)

  const handleEmbedOpen = (event: React.MouseEvent) => {
    event.stopPropagation()
    setEmbedDialogOpen(true)
  }

  const handleEmbedClose = (event: React.MouseEvent) => {
    event.stopPropagation()
    setEmbedDialogOpen(false)
  }

  return (
    <>
      <Dialog css={shareDialog} open={shareDialogOpen} onClose={onClose}>
        <DialogTitle>Share Risk Story</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isStoryPublic
              ? 'This Risk Story is public can be viewed by anyone with the link.'
              : 'This Risk Story is private and can only be viewed by those in your organisation with a Resilience Explorer® login.'}
          </DialogContentText>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 2 }}>
            <TextField
              style={{ flex: 1 }}
              size="small"
              type="url"
              variant="outlined"
              value={storyLink}
              slotProps={{
                input: {
                  readOnly: true,
                  sx: {
                    fontFamily: 'monospace',
                    fontSize: '0.8rem',
                    cursor: 'pointer',
                  },
                },
              }}
              onClick={(e) => {
                const target = e.target as HTMLInputElement
                target.select()
              }}
            />
            <Button
              variant="contained"
              size="small"
              onClick={onCopy(storyLink, 'Link copied.')}
              sx={{ flexShrink: 0 }}
            >
              Copy
            </Button>
          </Box>
          {isStoryPublic && (
            <Box sx={{ mt: 2 }}>
              <Button variant="outlined" size="small" onClick={handleEmbedOpen} fullWidth>
                Embed to website
              </Button>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            size="small"
            style={{ color: '#0074D3', margin: 10 }}
            onClick={onClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <RiskStoryEmbedScript
        embedDialogOpen={embedDialogOpen}
        storyLink={storyLink}
        handleCopy={onCopy}
        onClose={handleEmbedClose}
      />
    </>
  )
}
